import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import ax from "./auth/axios";
import { API_ROOT, API_ROOT1 } from "./utils/api-config";
import { connect } from "react-redux";
import { editDelivery } from "../actions/deliveryAction";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import moment from "moment";
import PinLocation from "./PinLocation";
import TextField from "@material-ui/core/TextField";

const token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
    "Content-Type": "application/json",
  },
};

class EditDelivery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      delivery_instructions: "",
      pick_up_time: "",
      drop_off_time: "",
      entered_dc_at: "",
      date: "",
      fulfillment_id: 0,
      order_id: 0,
      fsa_id: 0,
      bdate_id: 0,
      driver_id: 0,
      route_id: 0,
      pickup_driver: 0,
      pickup_route: 0,
      delivery_window: "",
      merchant_id: 0,
      custom_order: false,
      contact_customer: true,
      contact_via_sms_only: false,
      contact_via_email_only: false,
      number_of_bags: 0,
      delivery_notes: "",
      webbooking: false,
      price: 0,
      exchange: false,
      ontime: false,
      delivered: false,
      booking_index: "",
      cancelled: false,
      cancelled_by: "",
      cancelled_at: "",
      base_rate: "",
      out_of_zone_fee: "",
      overweight_fee: "",
      additional_standard_bag_fee: "",
      additional_overweight_bag_fee: "",
      show: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.props.requestDelivery;
    const { delivery } = this.props.delivery;

    this.setState({
      id: delivery.id,
      delivery_instructions: delivery.delivery_instructions
        ? delivery.delivery_instructions
        : "",
      date: delivery.date ? delivery.date : "",
      fulfillment_id: delivery.fulfillment_id ? delivery.fulfillment_id : "",
      order_id: delivery.order_id ? delivery.order_id : "",
      bdate_id: delivery.bdate_id ? delivery.bdate_id : "",
      driver_id: delivery.driver_id ? delivery.driver_id : "",
      route_id: delivery.route_id ? delivery.route_id : "",
      pickup_driver: delivery.pickup_driver ? delivery.pickup_driver : "",
      pickup_route: delivery.pickup_route ? delivery.pickup_route : "",
      delivery_window: delivery.delivery_window ? delivery.delivery_window : "",
      merchant_id: delivery.merchant_id ? delivery.merchant_id : "",
      fsa_id: delivery.fsa_id ? delivery.fsa_id : "",
      custom_order: delivery.custom_order ? delivery.custom_order : "",
      contact_customer: delivery.contact_customer
        ? delivery.contact_customer
        : false,
      contact_via_sms_only: delivery.contact_via_sms_only
        ? delivery.contact_via_sms_only
        : false,
      contact_via_email_only: delivery.contact_via_email_only
        ? delivery.contact_via_email_only
        : false,
      webbooking: delivery.webbooking ? delivery.webbooking : false,
      delivery_notes: delivery.delivery_notes ? delivery.delivery_notes : "",
      price: delivery.price ? delivery.price : "",
      exchange: delivery.exchange ? delivery.exchange : false,
      ontime: delivery.ontime ? delivery.ontime : false,
      booking_index: delivery.booking_index,
      delivered: delivery.delivered ? delivery.delivered : false,
      drop_off_time: delivery.drop_off_time ? delivery.drop_off_time : "",
      pick_up_time: delivery.pick_up_time ? delivery.pick_up_time : "",
      entered_dc_at: delivery.entered_dc_at ? delivery.entered_dc_at : "",
      booking_id: delivery.booking_id ? delivery.booking_id : "",
      cancelled: delivery.cancelled ? delivery.cancelled : false,
      cancelled_at: delivery.cancelled_at ? delivery.cancelled_at : "",
      cancelled_by: delivery.cancelled_by ? delivery.cancelled_by : "",
      base_rate: delivery.base_rate ? delivery.base_rate : "",
      out_of_zone_fee: delivery.out_of_zone_fee ? delivery.out_of_zone_fee : "",
      overweight_fee: delivery.overweight_fee ? delivery.overweight_fee : "",
      additional_standard_bag_fee: delivery.additional_standard_bag_fee
        ? delivery.additional_standard_bag_fee
        : "",
      additional_overweight_bag_fee: delivery.additional_overweight_bag_fee
        ? delivery.additional_overweight_bag_fee
        : "",
    });
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  toggleShow = () => this.setState({ show: !this.state.show });

  handleCancel = () => {
    ax.post(
      `${API_ROOT1}/deliveries/cancel.json?delivery_id=${this.props.delivery.delivery.id}`,
      config
    )
      .then(({ data }) => console.log(data))
      .then(() => this.props.updateDelivery(this.props.delivery.delivery.id));
    this.props.show();
  };

  handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData();
    // let token = "Bearer " + localStorage.getItem("token");
    // const config = {
    //   headers: {
    //     Authorization: token,
    //     "Content-Type": "application/x-www-form-urlencoded",
    //   },
    // };
    this.state.delivery_instructions &&
      formData.append(
        "delivery[delivery_instructions]",
        this.state.delivery_instructions
      );
    this.state.delivery_notes &&
      formData.append("delivery[delivery_notes]", this.state.delivery_notes);
    this.state.fulfillment_id &&
      formData.append("delivery[fulfillment_id]", this.state.fulfillment_id);
    this.state.order_id &&
      formData.append("delivery[order_id]", this.state.order_id);
    this.state.fsa_id && formData.append("delivery[fsa_id]", this.state.fsa_id);
    this.state.merchant_id &&
      formData.append("delivery[merchant_id]", this.state.merchant_id);
    formData.append("delivery[booking_id]", this.state.booking_id);
    this.state.driver_id &&
      formData.append("delivery[driver_id]", this.state.driver_id);
    this.state.route_id &&
      formData.append("delivery[route_id]", this.state.route_id);
    formData.append("delivery[pickup_driver]", this.state.pickup_driver);
    formData.append("delivery[pickup_route]", this.state.pickup_route);
    this.state.date && formData.append("delivery[date]", this.state.date);
    this.state.delivery_window &&
      formData.append("delivery[delivery_window]", this.state.delivery_window);
    this.state.custom_order &&
      formData.append("delivery[custom_order]", this.state.custom_order);
    this.state.contact_customer &&
      formData.append(
        "delivery[contact_customer]",
        this.state.contact_customer
      );
    this.state.number_of_bags &&
      formData.append("delivery[number_of_bags]", this.state.number_of_bags);
    this.state.webbooking &&
      formData.append("delivery[webbooking]", this.state.webbooking);
    this.state.price && formData.append("delivery[price]", this.state.price);
    formData.append("delivery[exchange]", this.state.exchange);
    formData.append("delivery[ontime]", this.state.ontime);
    this.state.booking_index &&
      formData.append("delivery[booking_index]", this.state.booking_index);
    formData.append("delivery[delivered]", this.state.delivered);
    this.state.drop_off_time &&
      formData.append("delivery[drop_off_time]", this.state.drop_off_time);
    this.state.pick_up_time &&
      formData.append("delivery[pick_up_time]", this.state.pick_up_time);
    this.state.entered_dc_at &&
      formData.append("delivery[entered_dc_at]", this.state.entered_dc_at);
    formData.append("delivery[base_rate]", this.state.base_rate);
    formData.append("delivery[out_of_zone_fee]", this.state.out_of_zone_fee);
    formData.append("delivery[overweight_fee]", this.state.overweight_fee);
    formData.append(
      "delivery[additional_standard_bag_fee]",
      this.state.additional_standard_bag_fee
    );
    formData.append(
      "delivery[additional_overweight_bag_fee]",
      this.state.additional_overweight_bag_fee
    );
    formData.append("delivery[cancelled]", this.state.cancelled);
    formData.append("delivery[cancelled_by]", this.state.cancelled_by);
    formData.append("delivery[cancelled_at]", this.state.cancelled_at);
    formData.append("commit", "edit");

    ax.patch(`${API_ROOT}/deliveries/${this.state.id}`, formData, config)
      .then((response) => this.props.editDelivery(response.data))
      .then(() => this.props.updateDelivery(this.state.id));
    this.props.show();
  }
  render() {
    const state = this.state;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridMerchantId">
            <Form.Label>Merchant ID</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.merchant_id}
              name="merchant_id"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridOrderId">
            <Form.Label>Order ID</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.order_id}
              name="order_id"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridFsaId">
            <Form.Label>Fsa ID</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.fsa_id}
              name="fsa_id"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridExchange">
            <Form.Label>Exchange</Form.Label>
            <Form.Check
              onChange={this.handleInputChange}
              checked={state.exchange}
              name="exchange"
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridBookingId">
            <Form.Label>Booking ID</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.booking_id}
              name="booking_id"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridBookingIndex">
            <Form.Label>Booking Index</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.booking_index}
              name="booking_index"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridDriverId">
            <Form.Label>Driver ID</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.driver_id}
              name="driver_id"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formRouteId">
            <Form.Label>Route ID</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.route_id}
              name="route_id"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridPUDriver">
            <Form.Label>Pickup Driver ID</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.pickup_driver}
              name="pickup_driver"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formPURouteId">
            <Form.Label>Pickup Route ID</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.pickup_route}
              name="pickup_route"
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridBags">
            <Form.Label>Number of Bags/Boxes</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.number_of_bags}
              name="number_of_bags"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridPrice">
            <Form.Label>Price, cents</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.price}
              name="price"
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridInstructions">
            <Form.Label>Delivery Instructions</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.delivery_instructions}
              name="delivery_instructions"
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridNotes">
            <Form.Label>Delivery Notes</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.delivery_notes}
              name="delivery_notes"
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridBaseRate">
            <Form.Label>Base rate</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.base_rate}
              name="base_rate"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridOutZoneFee">
            <Form.Label>Out of Zone fee</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.out_of_zone_fee}
              name="out_of_zone_fee"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridOverweightFee">
            <Form.Label>Overweight fee</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.overweight_fee}
              name="overweight_fee"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridAdditionalStandardBagFee">
            <Form.Label>Additional Standard Bag fee</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.additional_standard_bag_fee}
              name="additional_standard_bag_fee"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridAdditionalOverweightBagFee">
            <Form.Label>Additional Overweight Bag fee</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.additional_overweight_bag_fee}
              name="additional_overweight_bag_fee"
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridPickedAt">
            {/* <Form.Label>Delivered At</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.drop_off_time}
              name="drop_off_time"
            /> */}
            <TextField
              name="pick_up_time"
              label="Picked Up At"
              onChange={this.handleInputChange}
              type="datetime-local"
              defaultValue={moment(state.pick_up_time).format(
                "yyyy-mm-ddThh:mm"
              )}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridDeliveredAt">
            <TextField
              name="drop_off_time"
              label="Delivered At"
              onChange={this.handleInputChange}
              type="datetime-local"
              defaultValue={moment(state.drop_off_time).format(
                "yyyy-mm-ddThh:mm"
              )}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridEnteredDcAt">
            {/* <Form.Label>Entered DC At</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.entered_dc_at}
              name="entered_dc_at"
            /> */}
            <TextField
              name="entered_dc_at"
              label="Entered DC At"
              onChange={this.handleInputChange}
              type="datetime-local"
              defaultValue={moment(state.entered_dc_at).format(
                "yyyy-mm-ddThh:mm"
              )}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridDelivered">
            <Form.Label>Delivered</Form.Label>
            <Form.Check
              onChange={this.handleInputChange}
              checked={state.delivered}
              name="delivered"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridOntime">
            <Form.Label>Ontime</Form.Label>
            <Form.Check
              onChange={this.handleInputChange}
              checked={state.ontime}
              name="ontime"
            />
          </Form.Group>
        </Form.Row>
        {this.props.delivery.delivery.cancelled && (
          <Form.Row>
            <Form.Group as={Col} controlId="formGridcancelled">
              <Form.Label>Cancelled</Form.Label>
              <Form.Check
                onChange={this.handleInputChange}
                checked={state.cancelled}
                name="cancelled"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridCancelledBy">
              <Form.Label>Cancelled by</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                value={state.cancelled_by}
                name="cancelled_by"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridCancelledAt">
              <Form.Label>Cancelled at</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                value={state.cancelled_at}
                name="cancelled_at"
              />
            </Form.Group>
          </Form.Row>
        )}
        <Button variant="primary" type="submit">
          Edit Delivery
        </Button>
        {!this.props.delivery.delivery.cancelled && (
          <Button variant="danger" onClick={this.handleCancel}>
            Cancel Delivery
          </Button>
        )}
      </Form>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  editDelivery: (delivery) => dispatch(editDelivery(delivery)),
});
export default withRouter(connect(null, mapDispatchToProps)(EditDelivery));
